import { BasketActionTypes, PromoBasketPopupActionTypes } from '../../../enums/ActionEnums';
const initialState = {
    collapsed: true,
    message: null,
};
export const promoBasketPopupReducer = (state = initialState, action) => {
    switch (action.type) {
        case BasketActionTypes.ADD_SUCCESS:
        case BasketActionTypes.ADD_BUNDLE_SUCCESS:
        case PromoBasketPopupActionTypes.POPUP_CLOSE:
            return Object.assign(Object.assign({}, state), { collapsed: true });
        case PromoBasketPopupActionTypes.POPUP_OPEN:
            return Object.assign(Object.assign({}, state), { collapsed: false, message: action.payload });
        default:
            return state;
    }
};
